export default "<div class=\"parents\" *ngIf=\"loading\">\r\n    <i class=\"loader\"></i>\r\n</div>\r\n"